export default function gallery() {

    let $items = jQuery();
    let index = 0;

    const show = (i) => {
        index = (i + $items.length) % $items.length;
        jQuery('.block__gallery-lightbox img').attr('src', $items.eq(index).attr('href'));
    };

    const close = () => {
        jQuery('.block__gallery-lightbox').remove();
        jQuery(document).off('keydown.gallery');
    };

    jQuery(document).on('click', '.block__gallery-item', function (e) {
        e.preventDefault();

        $items = jQuery(this).closest('.block__gallery-grid').find('.block__gallery-item');

        jQuery('body').append(`
            <div class="block__gallery-lightbox">
                <button class="block__gallery-close" aria-label="Sluiten">&times;</button>
                ${$items.length > 1 ? '<button class="block__gallery-prev" aria-label="Vorige">&lsaquo;</button><button class="block__gallery-next" aria-label="Volgende">&rsaquo;</button>' : ''}
                <img src="" alt="">
            </div>
        `);

        show($items.index(this));

        jQuery(document).on('keydown.gallery', (e) => {
            if (e.key === 'Escape') close();
            if (e.key === 'ArrowLeft') show(index - 1);
            if (e.key === 'ArrowRight') show(index + 1);
        });
    });

    jQuery(document).on('click', '.block__gallery-lightbox', function (e) {
        if (jQuery(e.target).is('.block__gallery-prev')) return show(index - 1);
        if (jQuery(e.target).is('.block__gallery-next')) return show(index + 1);
        if (!jQuery(e.target).is('img')) close();
    });

}
